import { Component, OnInit, ViewChild } from '@angular/core'
import { MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { MatDialog } from '@angular/material/dialog'
import { MatAccordion } from '@angular/material/expansion'
import { Lector } from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import { PalletLabelComponent } from '../pallet-label/pallet-label.component'

@Component({
  selector: 'app-opciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.css']
})
export class OpcionesComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion
  datosArray: Lector
  IdPdfIm: any
  isLdt=false;
  constructor (
    private _bottomSheetRef: MatBottomSheetRef<OpcionesComponent>,
    private auten: AuthenticationService
  ) {
    var idPdf = JSON.parse(localStorage.getItem('pdf'))
    this.IdPdfIm = Number(idPdf.ID)
    if (this.auten.currentUserValue.company=='LDT20') {
      this.isLdt=true;
    }
  }

  openLink (event: MouseEvent): void {
    this._bottomSheetRef.dismiss()
    event.preventDefault()
  }

  ngOnInit (): void {}
  OpenDialogMasivo (tipo: any): void {
    var url = environment.apiComplement
    if (tipo == 'Receive_Summary') {
      url += '/Views/Partner/receiving/receivesummary1.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Labels') {
      url += '/Views/Partner/shipping/genericlabel.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Pallet_Labels') {
      url += '/Views/Partner/receiving/palletlabel.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Discrepancy_Report') {
      url +=
        '/Views/Partner/receiving/discrepancySummary.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Receiving_by_Pallets') {
      url +=
        '/Views/Partner/receiving/receivingbypallets.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Receiving_by_Pallets_Carton') {
      url += '/Views/Partner/receiving/receiveSummary1.aspx?id=' + this.IdPdfIm
    } else if (tipo == 'Page_Pallet_Label') {
      if (this.auten.currentUserValue.company == 'LDT20') {
        url +=
          '/Views/Partner/receiving/PalletBigLabelWarehouse.aspx?id=' +
          this.IdPdfIm
      } else {
        url += '/Views/Partner/receiving/PalletBigLabel.aspx?id=' + this.IdPdfIm
      }
    } else if (tipo == 'Page_Pallet_Label_kem') {
      if (this.auten.currentUserValue.company == 'LDT20') {
        url +=
          '/Views/Partner/receiving/PalletBigLabelWarehouseKemflo.aspx?id=' +
          this.IdPdfIm
      } else {
        url += '/Views/Partner/receiving/PalletBigLabel.aspx?id=' + this.IdPdfIm
      }
    }else if (tipo == 'Page_Pallet_Group') {
      if (this.auten.currentUserValue.company == 'LDT20') {
        url +=
          '/Views/Partner/receiving/receivingbypalletsGroup.aspx?id=' +
          this.IdPdfIm+'&NTILE=26'
      } else {
      
      }
    }else if (tipo == 'Invoice') {
      url=environment.wmsdocument
      url +=
      '/Warehouse/Invoice?id_order=' +
      this.IdPdfIm+'&type_order=Receiving'
    }

    window.open(url)
  }
}
